import { z } from "zod";
import { categoryPrefixSchema } from "./categories.js";
/** All product searches use warehouse category scope and the same SKU text fields. */
export const PRODUCT_SEARCH = {
    delayMs: 300,
    maxLength: 100,
    placeholder: "搜索商品名称、编码或规格",
    searchWithinCategory: true,
    multiplicationPattern: String.raw `\s*[*xX×＊ｘＸ]\s*`,
    multiplicationSymbol: "×",
    fields: ["productCode", "productName", "skuCode", "specification"],
};
export function normalizeProductSearchQuery(value) {
    return value.trim();
}
/** Normalize only for matching; product labels and the user's input keep their original text. */
export function normalizeProductSearchText(value) {
    return value.replace(new RegExp(PRODUCT_SEARCH.multiplicationPattern, "gu"), PRODUCT_SEARCH.multiplicationSymbol)
        .trim().toLocaleLowerCase("zh-CN");
}
export function matchesProductSearch(candidate, query) {
    const needle = normalizeProductSearchText(query);
    return !needle || PRODUCT_SEARCH.fields.some((field) => normalizeProductSearchText(candidate[field] ?? "").includes(needle));
}
/** Keep the warehouse's selected branch, including its descendants, while searching. */
export function effectiveProductCategory(query, categoryId) {
    if (!PRODUCT_SEARCH.searchWithinCategory && normalizeProductSearchQuery(query))
        return "";
    return categoryId === "all" ? "" : categoryId ?? "";
}
export function productSearchLikePattern(query) {
    return `%${normalizeProductSearchText(query).replace(/[\\%_]/g, "\\$&")}%`;
}
/** Unicode scalar order matches PostgreSQL's UTF-8 C collation, including mixed SKU codes. */
export function compareProductSearchCodes(left, right) {
    let leftIndex = 0;
    let rightIndex = 0;
    while (leftIndex < left.length && rightIndex < right.length) {
        const leftPoint = left.codePointAt(leftIndex);
        const rightPoint = right.codePointAt(rightIndex);
        if (leftPoint !== rightPoint)
            return leftPoint - rightPoint;
        leftIndex += leftPoint > 0xffff ? 2 : 1;
        rightIndex += rightPoint > 0xffff ? 2 : 1;
    }
    return left.length - right.length;
}
export const productSearchQuerySchema = z.string().trim().max(PRODUCT_SEARCH.maxLength, "搜索内容过长").default("");
export const productSearchFiltersSchema = z.object({
    query: productSearchQuerySchema,
    categoryId: z.string().uuid().optional(),
    categoryPrefix: categoryPrefixSchema.optional(),
});
